import React, { Fragment, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { AddCircleOutline, Cancel } from "@material-ui/icons";

import cardBodyStyle from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function AnotherEconomicSector(props) {
  const classes = useStyles();
  const [open, setOpen] = useState(props.callbackTrue);

  const [values, setValues] = useState({
    another: "",
  });
  const CHARACTER_LIMIT = 50;

  const [errorFieldAnother, seterrorFieldAnother] = useState(false);

  const handleSave = () => {
    seterrorFieldAnother(false);

    if (values.another.length === 0) {
      seterrorFieldAnother(true);
    } else {
      setOpen(false);
      props.callbackValues(values);
    }
  };

  const handleClose = () => {
    props.callbackValues("");
    setOpen(false);
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    seterrorFieldAnother(false);
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        // onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers style={{ padding: 50 }}>
          <form className={classes.root} noValidate autoComplete="off">
            <Grid
              container
              spacing={3}
              style={{
                paddingTop: "1%",
                paddingRight: "3%",
                paddingLeft: "3%",
              }}
            >
              <Grid item xs={12} sm={12}>
                <center>
                  <AddCircleOutline
                    style={{
                      fontSize: "50px",
                      color: "#000",
                      verticalAlign: "middle",
                    }}
                  ></AddCircleOutline>
                </center>
                <TextField
                  multiline
                  name="another"
                  value={values.another}
                  error={errorFieldAnother}
                  onChange={handleChange("another")}
                  fullWidth
                  required
                  inputProps={{
                    maxLength: CHARACTER_LIMIT,
                  }}
                  label="Otro sector económico"
                  helperText={`${values.another.length}/${CHARACTER_LIMIT}`}
                  margin="dense"
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <center>
                  <Button onClick={handleSave} className={classes.buttonSubmit}>
                    Ingresar
                  </Button>
                </center>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
